/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Export_Error_DatesInputs */



/**
* | output |
* | --- |
* | "Start date must be before end date" |
*
* @param {Intervention_Plan_Export_Error_DatesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_export_error_dates = /** @type {((inputs?: Intervention_Plan_Export_Error_DatesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Export_Error_DatesInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Start date must be before end date")
	return /** @type {LocalizedString} */ ("La date de début doit être inférieure à la date de fin")
});